export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/test.worker.9e295df4.worker.js");
}
